import React, { Component } from 'react';
import { Box } from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const colors = [
    "#26A69A",
    // "#66BB6A",
    // "#9CCC65",
    "#D4E157",
    // "#FFEE58",
    // "#FFCA28",
    "#FFA726",
    // "#FF7043",

    // "#f44336",
    "#E91E63",
    // "#9C27B0",
    // "#673AB7",
    "#3F51B5",
    // "#2196F3",
    // "#03A9F4",
    "#00BCD4",
    // "#009688",
    // "#4CAF50",
    "#8BC34A",
    // "#CDDC39",
    // "#FFEB3B",
    "#FFC107",
    // "#FF9800",
    // "#FF5722",

    "#e53935",
    // "#D81B60",
    // "#8E24AA",
    "#5E35B1",
    // "#3949AB",
    // "#1E88E5",
    "#039BE5",
    // "#00ACC1",
    // "#00897B",
    "#43A047",
    // "#7CB342",
    // "#C0CA33",
    "#FDD835",
    // "#FFB300",
    // "#FB8C00",
    "#F4511E",

    // "#d32f2f",
    // "#C2185B",
    "#7B1FA2",
    // "#512DA8",
    // "#303F9F",
    "#1976D2",
    // "#0288D1",
    // "#0097A7",
    "#00796B",
    // "#388E3C",
    // "#689F38",
    "#AFB42B",
    // "#FBC02D",
    // "#FFA000",
    "#F57C00",
    // "#E64A19",

    // "#c62828",
    "#AD1457",
    // "#6A1B9A",
    // "#4527A0",
    "#283593",
    // "#1565C0",
    // "#0277BD",
    "#00838F",
    // "#00695C",
    // "#2E7D32",
    "#558B2F",
    // "#9E9D24",
    // "#F9A825",
    "#FF8F00",
    // "#EF6C00",
    // "#D84315",

    "#b71c1c",
    // "#880E4F",
    // "#4A148C",
    "#311B92",
    // "#1A237E",
    // "#0D47A1",
    "#01579B",
    // "#006064",
    // "#004D40",
    "#1B5E20",
    // "#33691E",
    // "#827717",
    "#F57F17",
    // "#FF6F00",
    // "#E65100",
    "#BF360C",

]

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

class RechartsLine extends Component {
    state = {  }
    render() {
        let LABELS = !isEmpty(this.props.data)  ? Object.keys(this.props.data[0]).filter(area => area !== "name") : []
        
        return (
            <Box>
                <ResponsiveContainer  width="100%" height={400}>
                    <AreaChart
                        // width={700}
                        // height={400}
                        data={this.props.data || data}
                        margin={{
                            top: 10,
                            right: 30,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        {LABELS.map( (area, i) =>
                                <Area type="monotone" dataKey={area} stroke={colors[i]} fill={colors[i]} />
                        )}
                    </AreaChart>
                </ResponsiveContainer>
            </Box>
        );
    }
}

export default RechartsLine;
// export default class Example extends PureComponent {
// //   static demoUrl = 'https://codesandbox.io/s/stacked-area-chart-ix341';

//   render() {
//     return (
//       <ResponsiveContainer width="100%" height="100%">
//         <AreaChart
//           width={500}
//           height={400}
//           data={data}
//           margin={{
//             top: 10,
//             right: 30,
//             left: 0,
//             bottom: 0,
//           }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="name" />
//           <YAxis />
//           <Tooltip />
//           <Area type="monotone" dataKey="uv" stackId="1" stroke="#8884d8" fill="#8884d8" />
//           <Area type="monotone" dataKey="pv" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
//           <Area type="monotone" dataKey="amt" stackId="1" stroke="#ffc658" fill="#ffc658" />
//         </AreaChart>
//       </ResponsiveContainer>
//     );
//   }
// }
